import { AUTH_ERROR, AUTH_SUCCESS, LOG_OUT, TOGGLE_AUTH_MODAL, UPDATE_AUTH_TOKEN, SET_USER, } from './mutations-types'

export default {
  [TOGGLE_AUTH_MODAL] (state, value) {
    state.showAuthModal = value
  },
  [AUTH_SUCCESS] (state, { token, name, email, }) {
    state.user = {
      name,
      email,
    }
  },
  [AUTH_ERROR] (state) {
    state.user = null
  },
  [LOG_OUT] (state) {
    state.user = null
  },
  [SET_USER] (state, { email, name, }) {
    if (email && name) {
      state.user = {
        email,
        name,
      }
    } else {
      state.user = null
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js